<template>
  <div>
    <Header></Header>

    <div class="ui container">
      <form class="ui form">
        <h4 class="ui dividing header">STEP 1</h4>

        <div class="field">
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              name="email_name"
              v-model="name"
              true-value="1"
              false-value="0"
            />
            <label
              >Would you like to require a first name and email in order to
              submit a question?
            </label>
          </div>
        </div>
        <h4 class="ui dividing header">STEP 2</h4>

        <div class="field">
          Please set the maximum character length of a question
          <input type="text" v-model="characters" maxlength="3" /> characters
        </div>
        <h4 class="ui dividing header">STEP 3</h4>
        <div class="field">
          What type of button would you like to place on your website?
          <div class="ui horizontal divider">
            All Colors
          </div>
          <span
            class="ui button"
            style="background: #B03060; color: #FFFF"
            @click="changeColor('B03060')"
            >Red</span
          >
          <span
            class="ui  button"
            style="background: #FE9A76; color: #FFFF"
            @click="changeColor('FE9A76')"
            >Orange</span
          >
          <span
            class="ui button"
            style="background: #FFD700; color: #FFFF"
            @click="changeColor('FFD700')"
            >Yellow</span
          >
          <span
            class="ui button"
            style="background: #32CD32; color: #FFFF "
            @click="changeColor('32CD32')"
            >Olive</span
          >
          <span
            class="ui button"
            style="background: #016936; color: #FFFF "
            @click="changeColor('016936')"
            >Green</span
          >
          <span
            class="ui button"
            style="background: #008080; color: #FFFF "
            @click="changeColor('008080')"
            >Teal</span
          >
          <span
            class="ui button"
            style="background: #0E6EB8; color: #FFFF "
            @click="changeColor('0E6EB8')"
            >Blue</span
          >
          <span
            class="ui button"
            style="background: #EE82EE; color: #FFFF "
            @click="changeColor('EE82EE')"
            >Violet</span
          >
          <span
            class="ui button"
            style="background: #B413EC; color: #FFFF "
            @click="changeColor('B413EC')"
            >Purple</span
          >
          <span
            class="ui button"
            style="background: #FF1493; color: #FFFF "
            @click="changeColor('FF1493')"
            >Pink</span
          >
          <span
            class="ui button"
            style="background: #A52A2A; color: #FFFF "
            @click="changeColor('A52A2A')"
            >Brown</span
          >
          <span
            class="ui button"
            style="background: #A0A0A0; color: #FFFF "
            @click="changeColor('A0A0A0')"
            >Grey</span
          >
          <span
            class="ui button"
            style="background: #000000; color: #FFFF "
            @click="changeColor('000000')"
            >Black</span
          >
        </div>
        <div class="field" v-if="widget">
          <label
            >Simply copy and paste this simple line of code into your website
            source code to add ResponseQue to your website.
          </label>
          <textarea id="widgetText" rows="10"></textarea>
        </div>
      </form>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "../components/Header";
export default {
  name: "generateWidget",
  components: { Header },
  data() {
    return {
      name: 0,
      characters: 250,
      widget: false,
      color: "0E6EB8"
    };
  },
  methods: {
    async showScript() {
      await this.showWidget();
      await this.generateWidget();
    },
    async showWidget() {
      this.widget = true;
    },
    async generateWidget() {
      let generatedWidgetCode =
        `<` +
        `script type="text/javascript">  
        var name = ${this.name};
	      var color= '${this.color}' ;
        var quesMaxChar='${this.characters}';
        <` +
        `/script>`;
      let widgetText =
        "<" +
        "script type='text/javascript' src='https://myresponseque.com/public/js/widgetgentr.js'> </" +
        "script>";
      $("#widgetText").val(generatedWidgetCode + widgetText);
    },
    async changeColor(color) {
      this.color = color;
      await this.showWidget();
      await this.generateWidget();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GenerateWidget.vue